<template>
    <div class="important-page-c display--flex fd--column">
        <!-- 搜索 -->
        <div class="search-form btn-2b5a95">
            <div
                    class="l-w"
                    :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
            >
                <el-form
                        label-position="right"
                        :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
                        :model="searchForm"
                        @submit.native.prevent
                >
                    <el-form-item label="收款日期始:">
                        <el-date-picker v-model="searchForm.t1" type="date" placeholder="选择日期" @keyup.enter.native="seach"
                                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="收款日期止:">
                        <el-date-picker v-model="searchForm.t2" type="date" placeholder="选择日期" @keyup.enter.native="seach"
                                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item label="跟进人:">
                        <el-input
                                v-model.trim="searchForm.followusername"
                                @keyup.enter.native="seach"
                                clearable />
                    </el-form-item>

                    <el-form-item label="教学点:">
                        <el-input
                                v-model.trim="searchForm.schoolorgname"
                                @keyup.enter.native="seach"
                                clearable />
                    </el-form-item>

                </el-form>
            </div>
            <div class="r-w">
                <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click="seach"
                        :loading="!$store.state.global.isEndRequest"
                        class="btn-2b5a95"
                >搜索</el-button
                >
                <el-button type="primary" @click="resetQuery">重置</el-button>
                <el-button
                        type="primary"
                        :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
                        v-if="$store.state.global.searchExtend_1"
                        class="btn-2b5a95"
                        @click="onExtendClick('isSearchExtend_1')"
                >{{ $store.state.global.searchExtendText_1 }}</el-button>
            </div>
        </div>

        <!-- 按钮操作 -->
        <div
                class="Btn-w eaf4ff-btn"
                v-if="tableRes.buttonlist && tableRes.buttonlist.length"
                :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
        >
            <div
                    class="btn-l"
                    v-if="tableRes.buttonlist"
                    :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
            >
                <el-button
                        v-for="(item, index) in tableRes.buttonlist"
                        :key="index"
                        type="primary"
                        @click="onClickBtn(item.buttonname)"
                >{{ item.name }}
                </el-button>
            </div>
            <div class="Btn-extend">
                <el-button
                        type="primary"
                        v-if="$store.state.global.btnExtend_1"
                        class="btn-2b5a95"
                        :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
                        @click="onExtendClick('isBtnExtend_1')"
                >{{ $store.state.global.BtnExtendText_1 }}</el-button
                >
            </div>
        </div>

        <!-- 表格 -->
        <el-table
                :data="tableRes.list"
                border
                stripe
                :header-cell-style="{ background: '#044d8c', color: '#fff'}"
                ref="multipleTable"
                style="width: 100%"
                :cell-style="{ padding: 0 }"
                @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{scope.$index+1}}
                </template>
            </el-table-column>
            <el-table-column label="姓名" prop="studentname"  align="center" width="80"/>
            <el-table-column label="手机号" prop="mobile"  align="center" width="120"/>
            <el-table-column label="项目类型" prop="projecttype"  align="center" width="100"/>
            <el-table-column label="费用类型" prop="type"  align="center"/>
            <el-table-column label="收费内容" prop="content" align="center"/>
            <el-table-column label="应收" prop="shouldrecv" align="center" width="70"/>
            <el-table-column label="实收"  prop="realrecv" align="center" width="70"/>
            <el-table-column label="退费"  prop="feebackmoney" align="center" width="70"/>
            <el-table-column label="收据号"  prop="codes" align="center"/>
            <el-table-column label="收款时间" align="center">
                <template slot-scope="scope">
                    {{ scope.row.shoukuantime | formatDate("YYYY-MM-DD") }}
                </template>
            </el-table-column>
            <el-table-column label="跟进人"  prop="followusername" align="center"/>
            <el-table-column label="教学点"  prop="schoolorgname" align="center"/>

        </el-table>

        <!-- 分页 -->
        <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="pageinfo.pageindex"
                :page-size="pageinfo.pagesize"
                :page-sizes="[10, 20, 30, 40, 50]"
                layout="total, prev, pager, next, jumper"
                :total="tableRes.totalcount"
        ></el-pagination>
    </div>
</template>
<script>
    import E from "wangeditor";
    import { part } from "@/utils/mixins";
    import { mapActions } from "vuex";

    import {
        performance_count,
        performance_export,
    } from "@/request/api/allChildrenProject";
    import { myRequest } from "@/request/index";
    import {
        selectCheck,
        confirmCallBack,
        messageTip,
        createObjParams,
        formatDare,
    } from "@/utils/util";

    export default {
        mixins: [part],
        name:"count",
        components: {},
        props: {},
        data() {
            return {
                itemId: null, //首表格项id
                searchForm: {
                    flag: 0,
                },
                tableRes: {}, //列表接口
                pageinfo: {
                    pageindex: 1,
                    pagesize: 10,
                }, //页数查询
                multipleSelection: [], //选中的表格项
                leveltypeList:[]
            };
        },
        created() {
            this.getDataList();
            window.addEventListener("keyup", this.enterSelect);
        },
        methods: {
            ...mapActions("global", ["onExtendClick", "isExpand"]),
            ...mapActions("selectData", ["dic_combox"]),
            enterSelect(e){
                if(e.keyCode == 13) {
                    this.getDataList();
                }
            },
            visibleIyear(e) {
                if(!e) {
                    this.$refs.iyear.blur();
                }
            },
            visibleLeveval(e) {
                if(!e) {
                    this.$refs.levelval.blur();
                }
            },
            //搜索 click
            seach() {
                this.pageinfo.pageindex = 1;
                this.search();
                this.searchForm.flag = 1;
            },
            search() {
                if(this.searchForm !== null) {
                    this.getDataList();
                }
            },
            reset() {
                this.searchForm = {
                    t1: null,
                    t2: null,
                    followusername: null,
                    schoolorgname: null,
                },
                    this.searchForm.flag = 0;
            },
            //重置
            resetQuery() {
                this.reset();
                this.getDataList();
            },
            //列表查询 api
            getDataList() {
                myRequest({
                    url: performance_count,
                    data: Object.assign(this.searchForm, this.pageinfo),
                }).then((res) => {
                    if (res.data.code === "200") {
                        this.tableRes = res.data.data;
                    }else if (res.data.code === "0") {
                        this.tableRes = res.data.data;
                    }
                });
            },
            //切换当前页
            handleCurrentChange(val) {
                this.pageinfo.pageindex = val;
                this.getDataList();
            },
            //触发所有btn方法
            onClickBtn(methodsName) {
                this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
            },
            //刷新 click
            btnReload() {
                this.getDataList();
                this.searchForm.flag = 0;
            },
            //选中表格数据改变时
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            //导出
            btnExport() {
                confirmCallBack({
                    title: "提示",
                    content: "根据搜索条件进行导出。",
                    success: () => {
                        window.location.href =
                            this.$url.Freemarker +
                            performance_export +
                            `?${createObjParams(this.searchForm)}`;
                    },
                    fail: () => {
                        messageTip({
                            message: "取消操作",
                            type: "info",
                        });
                    },
                });
            },



        },
    };
</script>

<style  lang="scss">

    @import "../../../assets/css/pulid.scss";

</style>
